<script>
   import Layout from '../../layouts/main'
   import PageHeader from '@/components/page-header'
   import appConfig from "@/app.config";
    
   export default {
      page: {
         title: "Sliders",
         meta: [
            {
               name: "description",
               content: appConfig.description,
            },
         ],
      },
      components: { Layout, PageHeader },
      data() {
         return {
            title: "Sliders",
            items: [
               {
                  text: "Sliders",
                  active: true,
               },                   
            ],

            listing_length: 10,
            keyword: '',
            status: null,

            sliders: [],
            slider: {
               id: null,
               slider : "",
            },
            
            modal_title: "Add Slider",
            button_title: "Save",
         };
      },
      mounted() {
    
      },

      methods: {
         showModal(modal) {
            this.$refs[modal].show();
         },

         hideModal(modal) {
            this.$refs[modal].hide();
         },

         editSlider() {            
            this.modal_title = "Edit Slider";
            this.button_title = "Update";
            this.slider.slider = "Slider 1"; 
              
            this.edit = true;
            this.showModal("slider-modal");
         },
         clearForm() {           
            
            this.modal_title = "Add Slider";
            this.button_title = "Add";
            this.slider.slider = "";           
            this.edit = false;
         },
      }
   }
</script>
    
<template>
   <Layout>
      <PageHeader :title="title" :items="items" />
      <div class="row">
         <div class="col-12">
            <div class="card">
               <div class="card-body">
                  <!-- <h4 class="card-title"></h4>
                  <p class="card-title-desc"></p> -->

                  <!----- top button area starts---->
                  <div class="row mb-3">
                     <div class="col-12">
                        <b-button v-b-modal.slider-modal variant="primary" class="float-end">Add Slider</b-button>
                     </div>
                  </div>
                  <!----- top button area ends---->

                  <!----- Listing length and search starts ----->
                  <div class="row mb-3">
                     <div class="col-sm-12 col-md-6">
                        <div class="listing-length" >
                           <label
                              >Show
                              <select class="form-control" v-model="listing_length">
                                 <option value="5">5</option>
                                 <option value="10">10</option>
                                 <option value="15">15</option>
                              </select>
                              entries
                           </label>
                        </div>                        
                     </div>
                     <div class="col-sm-12 col-md-6">
                                         
                        <!-- <div class="listing-filter me-2">
                           <label>
                              <select class="form-control" v-model="status">
                                 <option :value="null">All</option>
                                 <option value="1">Published</option>
                                 <option value="0">Unpublished</option>
                              </select>
                           </label>
                        </div>    -->
                     </div>
                  </div>
                  <!----- Listing length and search ends ----->

                  <!---- listing table starts -------->
                  <div class="table-responsive">
                     <table class="table table-bordered mb-0">
                        <thead class="table-light">
                               
                           <tr>
                              <th width="10%">SI No</th>
                              <th width="10%">Image</th>    
                              <th width="15%">Created On</th>
                              <th width="10%">Options</th>                              
                           </tr>
                        </thead>
                        <tbody>
                           <tr>
                              <td>1</td>  
                              <td>
                                 <img src="@/assets/images/small/img-1.jpg" style="width:100px;" alt="image">
                              </td>
                              <td>11 Nov 2021, 04:25 pm</td>
                              <td>                                
                                 <b-button variant="danger" class="btn-sm me-2 mb-2">Delete</b-button>
                                 <b-button variant="danger" class="btn-sm me-2 mb-2" >Unpublish</b-button>
                              </td>
                              
                           </tr>
                 
                        </tbody>
                     </table>
                  </div>
                  <!---- listing table ends -------->

                  <!----pagination starts ---> 
                  <caption class="float-start mt-4 d-block d-lg-inline">Showing 1 to 10 of 26 entries</caption>               
                  <ul class="pagination pagination-rounded mt-4 float-lg-end d-md-inline-flex">
                     <li class="page-item disabled">
                        <a href="#" class="page-link">
                           <i class="mdi mdi-chevron-left"></i>
                        </a>
                     </li>
                     <li class="page-item">
                        <a href="#" class="page-link">1</a>
                     </li>
                     <li class="page-item active">
                        <a href="#" class="page-link">2</a>
                     </li>
                     <li class="page-item">
                        <a href="#" class="page-link">3</a>
                     </li>
                     
                     <li class="page-item">
                        <a href="#" class="page-link">
                           <i class="mdi mdi-chevron-right"></i>
                        </a>
                     </li>
                  </ul>
                  <!----pagination ends --->
                  
                  <!---- modal starts ---->
                  <b-modal ref="slider-modal" id="slider-modal" :title="modal_title" hide-footer @hidden="clearForm()">
                     <b-form>                        
                        <div class="row"> 
                           <b-form-group class="col-lg-12">
                              <label>Image <span class="text-danger">*</span></label>
                              <input type="file" class="form-control">
                           </b-form-group>

                           <b-col md="12" class="mt-3">
                              <b-button type="submit" class="me-3" variant="primary">{{ button_title }}</b-button>
                              <b-button class="" variant="light" @click="hideModal('slider-modal')">Close</b-button>
                           </b-col>
                        </div>                       
                     </b-form>
                  </b-modal>
                  <!---- modal ends ----->

               </div>
            </div>
         </div>
      </div>
   </Layout>
</template>
